import { api } from "../client/axiosClient";
import { ENDPOINTS } from "../endpoints";
import { CustomResponseEntity, PaginatedResponse } from "../types/common";
import { UserDto, OrganizationDto } from "../types/dtos";
import { CreateAssignmentDto } from "../types/dtos/assignment.dto";

const NO_ORG_CONTEXT = { headers: { "X-Organization-Id": "" } };

export class AdminAssignmentService {
  async searchUsers(search: string): Promise<CustomResponseEntity<UserDto[]>> {
    return api.get(ENDPOINTS.users.base(), { params: { search }, ...NO_ORG_CONTEXT });
  }

  async getAllOrganizations(): Promise<CustomResponseEntity<OrganizationDto[]>> {
    return api.get(ENDPOINTS.organizations.adminAll(), NO_ORG_CONTEXT);
  }

  async getAllOrganizationsPaginated(params: {
    page: number;
    size: number;
    search?: string;
  }): Promise<CustomResponseEntity<PaginatedResponse<OrganizationDto>>> {
    return api.get(ENDPOINTS.organizations.adminAll(), { params, ...NO_ORG_CONTEXT });
  }

  async getOrganizationDetails(id: string): Promise<CustomResponseEntity<OrganizationDto>> {
    return api.get(ENDPOINTS.organizations.details(id), NO_ORG_CONTEXT);
  }

  async createAssignment(data: CreateAssignmentDto): Promise<CustomResponseEntity<unknown>> {
    return api.post(
      ENDPOINTS.admin.userRolesAsAdmin.create(data.userId),
      {
        roleId: data.roleId,
        name: `Role assignment for ${data.userId}`,
        isActive: true,
      },
      {
        headers: { "X-Organization-Id": data.organizationId },
      }
    );
  }

  async deleteAssignment(
    organizationId: string,
    userId: string,
    userRoleAssignmentId: string
  ): Promise<CustomResponseEntity<void>> {
    return api.delete(ENDPOINTS.admin.userRolesAsAdmin.delete(userId, userRoleAssignmentId), {
      headers: { "X-Organization-Id": organizationId },
    });
  }
}

export const adminAssignmentService = new AdminAssignmentService();
